import { CreateCollectionModal } from './components/CreateCollectionModal';

export default CreateCollectionModal;
